import React, { Fragment, useContext } from "react";
import styles from './thirdPartySubmitConfirmationContent.module.css';
import {
    ISaveAnswerApiPayload,
    ISaveTechnicalQuestionnaireRes
} from "../../../Models/thirdPartyQuestionnarieModels";
import agent from "../../../API/apiCalls";
import { toast } from "react-toastify";
import { UserContext, UserPayload } from "../../../Context/userContext";
import {
    IThirdPartyQuestionnaireContext, ThirdPartyQuestionnaireContext,
} from "../../../Context/thirdPartyQuestionnaireContext";
import { useNavigate } from "react-router-dom";
import { CommonResponseModel } from "../../../Models/tableDetailsModel";

interface IThirdPartySubmitConfirmationContent {
    CloseDialog: () => void;
}

const ThirdPartySubmitConfirmationContent = (props: IThirdPartySubmitConfirmationContent) => {

    const { questionsToAsk,setUserInfo } = useContext(ThirdPartyQuestionnaireContext) as IThirdPartyQuestionnaireContext;
    const { setShowLoader } = useContext(UserContext) as UserPayload;

    const navigate = useNavigate();

    const GetPayloadForSaveAnswer = () => {
        const data: ISaveAnswerApiPayload[] = [];

        for(let i=0; i<questionsToAsk.length; i++) {
            const section = questionsToAsk[i];
            for(let j=0; j<section.subCategories.length; j++) {
                const subSection = section.subCategories[j];
                for(let k=0; k<subSection.questions.length; k++) {
                    const question = subSection.questions[k];
                    data.push({
                        answer: question.answer ?? "",
                        questionVersionId: question.questionVersionId
                    })
                }
            }
        }
        return data;
    }

    const SubmitApi = async () => {
        try {
            setShowLoader(true);
            const payload: ISaveAnswerApiPayload[] = GetPayloadForSaveAnswer();
            const response: CommonResponseModel<ISaveTechnicalQuestionnaireRes> = await agent.SaveThirdPartyQuestionnaireAnswers.post(payload);
            console.log("Printing response", response);
            setShowLoader(false);
            if(response.flagStatus) {
                setUserInfo(response.value);
                props.CloseDialog();
                navigate("/third-party-questionnaire/success");
            }
        }
        catch (err) {
            setShowLoader(false);
            toast.success("Something went wrong, Please try again later!");
            console.log("Printing error", err);
        }
    }

    return (
        <Fragment>
            <div className={styles.actionOuter}>
                <button onClick={SubmitApi} className={`${styles.positiveButton} ${styles.actionButton}`}>Yes</button>
                <button onClick={props.CloseDialog} className={`${styles.negativeButton} ${styles.actionButton}`}>No</button>
            </div>
        </Fragment>
    );
};

export default ThirdPartySubmitConfirmationContent;